import React from "react";
import classnames from "classnames";

import constants from "../../../constants";
import messages from "../../../constants/messages";

const FileInput = ({
  name,
  onChange,
  showPreview,
  files,
  buttonClass,
  onError,
  onRemove,
}) => {
  const handleFile = e => {
    const file = e.target.files;
    const maxAllowedSize = 5 * 1024 * 1024;
    if (file[0].size > maxAllowedSize) {
      onError(messages.MAX_FILE_SIZE);
    } else if (
      !constants.DOCUMENT_SUPPORTED_TYPES.includes(
        file[0].name.split(".").pop().toLowerCase()
      )
    ) {
      onError(messages.INVALID_DOCUMENT);
    } else {
      const uploadedFiles = Array.from(file);
      onChange({
        [name]: files ? [...files, ...uploadedFiles] : uploadedFiles,
      });
      onChangeHandler(file);
    }
    e.target.value = null;
  };

  const onChangeHandler = file => {
    const uploadedFiles = Array.from(file);
    onChange({
      [name]: uploadedFiles,
    });
  };

  const handleRemove = index => {
    const newFiles = [...files];
    if (newFiles[index]?.src) {
      onRemove(newFiles[index]);
    }

    newFiles.splice(index, 1);
    onChange({ [name]: newFiles });
  };

  let inputElement;

  return (
    <>
      <div className="">
        <input
          ref={input => (inputElement = input)}
          accept="application/pdf,image/png,image/jpg,image/jpeg"
          type="file"
          style={{ display: "none" }}
          onChange={handleFile}
        />
        <div className="file-upload-container mb-3">
          {showPreview && files && files.length > 0 ? (
            files.map((file, index) => (
              <div className="" key={file.name}>
                {!constants.DOCUMENT_IMAGE_SUPPORTED_TYPES.includes(
                  file.name.split(".").pop().toLowerCase()
                ) ? (
                  <label
                    style={{
                      height: 10,
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#828282"
                      class="bi bi-file-earmark-check"
                      // viewBox="0 0 16 16"
                    >
                      <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z" />
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                    </svg>{" "}
                    {file.name}
                  </label>
                ) : (
                  <img
                    src={file.src || URL.createObjectURL(file)}
                    style={{
                      objectFit: "contain",
                      height: 150,
                      width: 300,
                      display: "inline",
                      // marginLeft: "30%",
                    }}
                    alt="img"
                  />
                )}

                <button
                  onClick={() => handleRemove(index)}
                  type="button"
                  className="close float-right"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            ))
          ) : (
            <button
              style={{
                border: "none",
                backgroundColor: "transparent",
                color: "#828282",
                height: 5,
              }}
              className={classnames("mb-3 file-upload-btn", buttonClass)}
              onClick={() => inputElement.click()}
            >
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.75 10H8.25V5.5H11.25L6 0.25L0.75 5.5H3.75V10ZM0.75 11.5H11.25V13H0.75V11.5Z"
                  fill="#707070"
                />
              </svg>{" "}
              &nbsp; Upload Document
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default FileInput;
